<template lang='pug'>
div.service-detail-panel
  //Notification Alert
  Notificationalert(
    v-if="controls.alert.display" 
    v-bind:alert="controls.alert"
  )

  //- Header con título y acciones
  .d-flex.align-items-center.justify-content-between.tw-mb-3
    .d-flex.align-items-center.tw-gap-2
      .tw-w-10.tw-h-10.tw-rounded-lg.tw-bg-teal-100.tw-flex.tw-items-center.tw-justify-center
        i.fa-solid.fa-concierge-bell.tw-text-teal-600.tw-text-lg
      div
        h5.tw-font-semibold.tw-text-gray-800.tw-mb-0 {{$I18n.t('vue.service_detail.title')}}
        span.tw-text-xs.tw-text-gray-500(v-if="record.id") Service assigned to this order
    
    //- Barra de botones  
    .d-flex.align-items-center.tw-gap-2(v-if="order.state.name!='COMPLETED' && order.state.name!='CANCELED'")
      .d-flex.align-items-center.tw-gap-2(v-if="record.id != undefined")
        div(@mouseover="showWarningDelete = true" @mouseout="showWarningDelete = false")
          app-icon-btn(
            data-kind="link",
            @click.native="removeServiceFromOrder(record.id)",
            data-icon="fa-solid fa-square-xmark",
            :data-label="$I18n.t('vue.service_detail.label_delete_service')",
            data-title=""
          )
        div
          app-icon-btn(
            data-kind="link",
            @click.native="reasignar_service()",
            data-icon="fa-solid fa-right-left",
            :data-label="$I18n.t('vue.service_detail.label_assign_service')",
            data-title=""
          )
      div(v-if="showTableServices == true")
        a.tw-inline-flex.tw-items-center.tw-px-3.tw-py-1.tw-rounded.tw-bg-red-50.tw-text-red-600.tw-text-sm.tw-cursor-pointer.hover_tw-bg-red-100(@click="cancel_assignment()")
          i.fa-solid.fa-square-xmark.tw-mr-1
          span {{$I18n.t('vue.service_detail.label_cancel_assignment')}}
  
  hr.tw-border-gray-200.tw-my-3
  
  .container-fluid.tw-px-0
    //- CASO: Servicio asignado
    div(v-if="record.id != undefined")
      .tw-bg-white.tw-rounded-lg.tw-border.tw-border-teal-200.tw-overflow-hidden
        //- Header de la tabla
        .tw-bg-teal-50.tw-px-4.tw-py-2.tw-border-b.tw-border-teal-200
          .d-flex.align-items-center.tw-gap-2
            i.fa-solid.fa-check-circle.tw-text-teal-600
            span.tw-font-medium.tw-text-teal-700 Assigned Service
        
        table.table.table-hover.service-styled-table.tw-mb-0
          thead.tw-bg-gray-50
            tr
              th.tw-text-left
                .d-flex.align-items-center.tw-gap-1
                  i.fa-solid.fa-tag.tw-text-gray-400.tw-text-xs
                  span {{$I18n.t('vue.service_detail.table_services_header_service')}}
              th.tw-text-center.tw-bg-purple-50.tw-border-l(style="border-left: 2px solid #e9d5ff !important;")
                .d-flex.align-items-center.tw-gap-1.justify-content-center
                  i.fa-solid.fa-calendar-days.tw-text-purple-400.tw-text-xs
                  span {{$I18n.t('vue.service_detail.table_services_header_frequency')}}
              th.tw-text-center.tw-bg-purple-50
                span {{$I18n.t('vue.service_detail.table_services_header_frequency_month')}}
              th.tw-text-center.tw-bg-green-50.tw-border-l(style="border-left: 2px solid #bbf7d0 !important;")
                .d-flex.align-items-center.tw-gap-1.justify-content-center
                  i.fa-solid.fa-dollar-sign.tw-text-green-400.tw-text-xs
                  span {{$I18n.t('vue.service_detail.table_services_header_base_price')}}
              th.tw-text-center.tw-bg-green-50
                span {{$I18n.t('vue.service_detail.table_services_header_breakdown')}}
              th.tw-text-center.tw-bg-green-50.tw-border-r(style="border-right: 2px solid #bbf7d0 !important;")
                span {{$I18n.t('vue.service_detail.table_services_header_total')}}
              th.tw-text-center.tw-w-16
          tbody
            tr.tw-bg-teal-50.tw-bg-opacity-30
              td
                .d-flex.align-items-center.tw-gap-2
                  .tw-w-8.tw-h-8.tw-rounded.tw-bg-teal-100.tw-flex.tw-items-center.tw-justify-center
                    i.fa-solid.fa-broom.tw-text-teal-600.tw-text-sm
                  span.tw-font-medium.tw-text-gray-800 {{ record.service }}
              td.tw-text-center.tw-bg-purple-50.tw-bg-opacity-50
                span.tw-inline-flex.tw-items-center.tw-px-2.tw-py-1.tw-bg-purple-100.tw-text-purple-700.tw-rounded.tw-text-xs.tw-font-medium
                  | {{ record.frequency }}
              td.tw-text-center.tw-bg-purple-50.tw-bg-opacity-50
                span.tw-text-gray-700 {{ record.frequency_month }}
              td.tw-text-center.tw-bg-green-50.tw-bg-opacity-50
                span.tw-text-gray-700 {{ record.base_price }}
              td.tw-text-center.tw-bg-green-50.tw-bg-opacity-50
                span.tw-text-gray-600.tw-text-sm {{ record.breakdown }}
              td.tw-text-center.tw-bg-green-50.tw-bg-opacity-50
                span.tw-font-bold.tw-text-green-700 {{ parseFloat(record.total.replace("$", "").replace(",", "").replace(" ", "")).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
              td.tw-text-center
                div(@mouseover="showWarningEdit = true" @mouseout="showWarningEdit = false")
                  edit-service-modal(
                    v-if="order.state.name!='COMPLETED' && order.state.name!='CANCELED'"
                    :data-icon='"fa-solid fa-pencil"'
                    :data-label="$I18n.t('vue.service_detail.edit')"
                    :data-mode='"edit"'
                    :data-item='JSON.stringify(record)'
                    @updated='updateService'
                  )
    
    //- CASO: Sin servicio asignado
    div(v-else)
      //- Vista: Botón para asignar
      div(v-if="showTableServices == false")
        .tw-text-center.tw-py-8.tw-bg-amber-50.tw-rounded-lg.tw-border.tw-border-amber-200
          .tw-w-16.tw-h-16.tw-bg-amber-100.tw-rounded-full.tw-flex.tw-items-center.tw-justify-center.tw-mx-auto.tw-mb-3
            i.fa-solid.fa-exclamation-triangle.tw-text-amber-500.tw-text-2xl
          p.tw-text-amber-700.tw-font-medium.tw-mb-3 {{$I18n.t('vue.service_detail.messages.no_service_assigned')}}
          button.tw-inline-flex.tw-items-center.tw-px-4.tw-py-2.tw-bg-teal-600.tw-text-white.tw-rounded-lg.tw-font-medium.hover_tw-bg-teal-700.tw-transition-colors(
            v-if="order.state.name!='COMPLETED' && order.state.name!='CANCELED'"
            @click="showTableServices = true"
          )
            i.fa-solid.fa-plus.tw-mr-2
            span {{$I18n.t('vue.service_detail.assign_service')}}
      
      //- Vista: Lista de servicios para seleccionar
      div(v-else)
        .tw-bg-white.tw-rounded-lg.tw-border.tw-border-gray-200.tw-overflow-hidden
          //- Header
          .tw-bg-gray-50.tw-px-4.tw-py-3.tw-border-b.tw-border-gray-200.d-flex.align-items-center.justify-content-between
            .d-flex.align-items-center.tw-gap-2
              i.fa-solid.fa-list.tw-text-gray-600
              h6.tw-font-semibold.tw-text-gray-700.tw-mb-0 {{$I18n.t('vue.service_detail.title_list_services')}}
              span.tw-bg-gray-200.tw-text-gray-700.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium
                | {{ other_services.length }}
            edit-service-modal(
              :data-icon='"fa-solid fa-plus"'
              :data-mode='"new"'
              :data-item='JSON.stringify([])'
              @updated='createNewService'
              :data-label="$I18n.t('vue.service_detail.label_create_service')"
            )
          
          //- Sin servicios disponibles
          .tw-text-center.tw-py-8(v-if="other_services.length==0")
            .tw-w-12.tw-h-12.tw-bg-gray-100.tw-rounded-full.tw-flex.tw-items-center.tw-justify-center.tw-mx-auto.tw-mb-2
              i.fa-solid.fa-inbox.tw-text-gray-400.tw-text-xl
            p.tw-text-gray-500.tw-mb-0 {{$I18n.t('vue.service_detail.messages.no_services_yet')}}
          
          //- Tabla de servicios disponibles
          div(v-else)
            table.table.table-hover.service-styled-table.tw-mb-0
              thead.tw-bg-gray-50
                tr
                  th.tw-text-left {{$I18n.t('vue.service_detail.table_services_header_service')}}
                  th.tw-text-center.tw-bg-purple-50 {{$I18n.t('vue.service_detail.table_services_header_frequency')}}
                  th.tw-text-center.tw-bg-purple-50 {{$I18n.t('vue.service_detail.table_services_header_frequency_month')}}
                  th.tw-text-center.tw-bg-green-50 {{$I18n.t('vue.service_detail.table_services_header_base_price')}}
                  th.tw-text-center.tw-bg-green-50 {{$I18n.t('vue.service_detail.table_services_header_breakdown')}}
                  th.tw-text-center.tw-bg-green-50 {{$I18n.t('vue.service_detail.table_services_header_total')}}
                  th.tw-text-center.tw-w-28
              tbody
                tr(v-for="(servicio, index) in other_services" :key="index" :class="{'tw-bg-teal-50': servicio.table.id == service_init_id}")
                  td
                    .d-flex.align-items-center.tw-gap-2
                      .tw-w-6.tw-h-6.tw-rounded.tw-bg-gray-100.tw-flex.tw-items-center.tw-justify-center
                        i.fa-solid.fa-broom.tw-text-gray-500.tw-text-xs
                      span {{ servicio.table.service }}
                  td.tw-text-center
                    span.tw-inline-flex.tw-items-center.tw-px-2.tw-py-1.tw-bg-purple-100.tw-text-purple-700.tw-rounded.tw-text-xs
                      | {{ servicio.table.frequency }}
                  td.tw-text-center.tw-text-gray-600 {{ servicio.table.frequency_month }}
                  td.tw-text-center.tw-text-gray-600 {{ servicio.table.base_price }}
                  td.tw-text-center.tw-text-gray-500.tw-text-sm {{ servicio.table.breakdown }}
                  td.tw-text-center.tw-font-semibold.tw-text-gray-700 {{ servicio.table.total }}
                  td.tw-text-center
                    div(v-if="servicio.table.id == service_init_id")
                      span.tw-inline-flex.tw-items-center.tw-px-2.tw-py-1.tw-bg-teal-100.tw-text-teal-700.tw-rounded.tw-text-xs.tw-font-medium
                        i.fa-solid.fa-check.tw-mr-1
                        | Selected
                    div(v-else)
                      button.tw-inline-flex.tw-items-center.tw-px-3.tw-py-1.tw-bg-blue-600.tw-text-white.tw-rounded.tw-text-sm.tw-font-medium.hover_tw-bg-blue-700.tw-transition-colors(@click="assignServiceToOrder(servicio)")
                        i.fa-solid.fa-check.tw-mr-1
                        span {{$I18n.t('vue.service_detail.select')}}
          
          //- Spinner Loading
          .tw-flex.justify-content-center.tw-py-4(v-if="state.sending")
            .spinner-border.spinner-border-sm.tw-text-teal-600(role="status")
  
  //- Alertas de advertencia
  .tw-mt-3(v-show="showWarningEdit")
    .tw-flex.tw-items-center.tw-gap-2.tw-px-4.tw-py-2.tw-bg-amber-50.tw-border.tw-border-amber-200.tw-rounded-lg
      i.fa-solid.fa-triangle-exclamation.tw-text-amber-500
      span.tw-text-amber-700.tw-text-sm {{$I18n.t('vue.service_detail.messages.modifying_affect_restaurant')}}
  .tw-mt-3(v-show="showWarningDelete")
    .tw-flex.tw-items-center.tw-gap-2.tw-px-4.tw-py-2.tw-bg-red-50.tw-border.tw-border-red-200.tw-rounded-lg
      i.fa-solid.fa-trash-can.tw-text-red-500
      span.tw-text-red-700.tw-text-sm {{$I18n.t('vue.service_detail.messages.remove_affect_order')}}

</template>

<script>
import CoreComponents from '../core';
const {ActiveValue}=require('../../core/active_support');
import {BackendService} from '../../services';
import EditServiceModal from './edit-service-modal.vue'

export default {
  props:['dataRecord', 
         'dataOtherServices',
         'dataOrder'
  ],
  components:{
    'edit-service-modal':EditServiceModal,
    ...CoreComponents
  },
  data:function(){
    this.order = this.dataOrder ? JSON.parse(this.dataOrder) : {
      id: undefined,
      state: { name: '' },
      subsidary: { id: undefined }
    };
    this.record = (this.dataRecord && this.dataRecord !== 'undefined') ? JSON.parse(this.dataRecord) : {
      id:undefined,
      service:undefined,
      frequency:undefined,
      frequency_month:undefined,
      base_price:undefined,
      breakdown:undefined,
      total:undefined,
      deleted_at:undefined
    };
    let self=this;
    return {
      service_init_id: this.record.id,
      other_services: this.dataOtherServices ? JSON.parse(this.dataOtherServices) : [],
      servicioSeleccionado: null,
      showWarningEdit: false,
      showWarningDelete: false,
      showTableServices: false,
      state:{
        show:true,
        edit:false,
        sending:false,
      },
      controls:{
        alert:{
          display: false,
          type: "",
          notice: "",
          message: "",
          link: {
            text: "",
            href: ""
          }
        },
      },
      values:{
        service: ActiveValue().setup((i)=>{
          i.setLabel(this.$I18n.t('vue.service_detail.label_service_name'));
          i.setValue(self.record.service);
          i.setKind('string');
          i.setInputKind('text');
          i.required();
        }),
        frequency: ActiveValue().setup((i)=>{
          i.setLabel(this.$I18n.t('vue.service_detail.label_service_frequency'));
          i.setValue(self.record.frequency);
          i.setKind('string');
          i.setInputKind('text');
          i.optional();
        }),
        frequency_month: ActiveValue().setup((i)=>{
          i.setLabel(this.$I18n.t('vue.service_detail.label_service_frequency_month'));
          i.setValue(self.record.frequency_month);
          i.setKind('string');
          i.setInputKind('text');
          i.required();
        }),
        base_price: ActiveValue().setup((i)=>{
          i.setLabel(this.$I18n.t('vue.service_detail.label_service_base_price'));
          i.setValue(self.record.base_price);
          i.setKind('string');
          i.setInputKind('text');
          i.required();
        }),
        breakdown: ActiveValue().setup((i)=>{
          i.setLabel(this.$I18n.t('vue.service_detail.label_service_breakdown'));
          i.setValue(self.record.breakdown);
          i.setKind('string');
          i.setInputKind('text');
          i.required();
        }),
        total: ActiveValue().setup((i)=>{
          i.setLabel(this.$I18n.t('vue.service_detail.label_service_total'));
          i.setValue(self.record.total);
          i.setKind('string');
          i.setInputKind('text');
          i.required();
        })
      }
    }
  },
  computed:{
    grid:function(){
      return [
        [this.values.service,     this.values.frequency, this.values.frequency_month],
        [this.values.base_price,  this.values.breakdown, this.values.total]
      ]
    }
  },
  methods:{
    removeServiceFromOrder() {
      let service = {
        table: {
          id: ""
        }
      }
      this.assignServiceToOrder(service)
    },
    assignServiceToOrder(service) {
      const self = this;
      this.state.sending = true;
      let params = {
        order_id: this.order.id,
        service_id: service.table.id
      }
      BackendService
        .assign_service_to_order(JSON.stringify(params))
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    createNewService:function(item){
      const self = this;
      
      // Validate that order has a subsidary (restaurant) assigned
      if (!this.order.subsidary || !this.order.subsidary.id) {
        console.error('Cannot create service: Order has no restaurant assigned');
        alert(this.$I18n.t('vue.service_detail.messages.no_restaurant_assigned', {default: 'Cannot create service: This order has no restaurant assigned'}));
        return;
      }
      
      this.state.sending = true;
      let params = JSON.stringify({
        id: this.order.subsidary.id,
        service: JSON.parse(item)
      })
      BackendService
        .create_subsidary_service(params)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          } else {
            console.error('Error creating service:', response);
            self.state.sending = false;
            alert(response.error || 'Error creating service');
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    updateService:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .service_update(params)
        .then((response) => {
          if (response.isOk) {
            let param = JSON.parse(params)
            console.log(param)
            let service = {
              table: {
                id: param.id
              }
            }
            this.assignServiceToOrder(service)
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    reasignar_service:function(params){
      const self = this;
      self.showTableServices = true;
      self.record.id = undefined;
    },
    cancel_assignment:function(params){
      const self = this;
      self.showTableServices = false; 
      self.record.id = self.service_init_id;
    },
  }
}
</script>

<style scoped>
.service-detail-panel {
  padding: 0.5rem;
}

.service-styled-table {
  font-size: 0.85rem;
}

.service-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
  font-weight: 600;
  color: #4b5563;
  font-size: 0.8rem;
}

.service-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}

.tw-border-l {
  border-left-width: 2px !important;
}

.tw-border-r {
  border-right-width: 2px !important;
}

.tw-bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}

.tw-bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}

.hover_tw-bg-teal-700:hover {
  background-color: #0f766e;
}

.hover_tw-bg-blue-700:hover {
  background-color: #1d4ed8;
}

.hover_tw-bg-red-100:hover {
  background-color: #fee2e2;
}
</style>
